var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCreationTabGeneralInfo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subnavigation-/-Product-Setup-/-4-1st",
    transform: "translate(-37.000000, -9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(37.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "currentColor",
    strokeWidth: 1.5,
    cx: 10,
    cy: 10,
    r: 9.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "currentColor",
    x: 9.41176471,
    y: 5.88235294,
    width: 1.17647059,
    height: 1.17647059
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "currentColor",
    x: 9.41176471,
    y: 8.23529412,
    width: 1.17647059,
    height: 7.05882353
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCreationTabGeneralInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/creationTabGeneralInfo.be9d1dc1.svg";
export { ForwardRef as ReactComponent };